module.exports = __webpack_public_path__ + "static/media/04.4b9f4fa7.jpg";